module.exports = __webpack_public_path__ + "img/mo.33cfa901.jpg";